import React from "react";
import { Helmet } from "react-helmet-async";

export default function Seo({ title, description, canonicalPath, ogImage, jsonLd, locale = "en" }) {
  const base = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = canonicalPath ? `${base}${canonicalPath}` : undefined;
  const fullTitle = title ? `${title} | BrandPassport` : "BrandPassport — the public index of brand transparency";
  return (
    <Helmet>
      <html lang={locale} />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {canonicalPath && <link rel="alternate" hrefLang="en" href={`${base}${canonicalPath}`} />}
      {canonicalPath && <link rel="alternate" hrefLang="it" href={`${base}${canonicalPath}?lang=it`} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      {canonical && <meta property="og:url" content={canonical} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
